import Box from "@mui/material/Box";
import {
  createSearchParams,
  Link as RouterLink,
  useNavigate,
} from "react-router-dom";
import Chip from "src/components/common/Chip";
import { Button } from "src/components/common/FormComponents";
import {
  CHIP_STATUS,
  PROJECT_STATUS,
  statusMessages2,
} from "src/constants/common";
import { path } from "src/constants/path";
import defaultStyles from "../styles";

export const RenderChip = (params) => {
  return (
    <Chip
      label={PROJECT_STATUS[params.row.chipTitle]}
      status={CHIP_STATUS[params.row.status]}
      description={params.row.remarks}
      showTooltip={PROJECT_STATUS[params.row.chipTitle] === "Rejected"}
    />
  );
};

export const RenderButton = (params) => {
  const occupiedArea = params?.row?.data?.landSpecification?.occupiedArea;

  return (
    <Box
      component={RouterLink}
      to={`${path.projectDetailView}?${createSearchParams({
        projectId: params.id,
        projectType: params.row.data.projectType,
        projectStatus: params.row.data.status,
        isOccupied: occupiedArea,
      })}`}
      sx={{
        ...defaultStyles.renderButtonText,
        textDecoration: "none",
        width: "100%",
        "& .MuiChip-root ": {
          width: "80%",
        },
      }}
    >
      <Chip
        label={`${params?.row?.registrationNo}`}
        status={
          Number(occupiedArea) === 0 && params.row.data.status === "APPROVED"
            ? "draft"
            : "success"
        }
      />
    </Box>
  );
};

export const RenderDemandDraft = (params) => {
  return (
    <>
      {params?.row?.status === "VERIFY_DEMAND_NOTE" ||
      params?.row?.status === "UNDER_QUERY" ? (
        <Box
          component={RouterLink}
          to={`${path.demandDraft}?${createSearchParams({
            id: params.id,
          })}`}
          sx={{ ...defaultStyles.renderButtonText }}
        >{`${
          params?.row?.status === "VERIFY_DEMAND_NOTE"
            ? "Verify Cost Estimate"
            : "Under Query"
        }`}</Box>
      ) : (
        <Box sx={{ color: "red !important" }}>
          {statusMessages2[params?.row?.status] ?? params?.row?.status}
        </Box>
      )}
    </>
  );
};

export const RenderViewDemandDraft = (params) => {
  const navigate = useNavigate();
  return (
    <>
      {params?.row?.status === "VERIFICATION_PENDING" ? (
        <Box
          component={RouterLink}
          to={`${path.viewDemand}?${createSearchParams({
            id: params.id,
          })}`}
          sx={{ ...defaultStyles.renderButtonText }}
        >{`${"Verify Payment"}`}</Box>
      ) : (
        <Box sx={{ color: "red !important" }}>-----</Box>
      )}
    </>
  );
};

export const RenderView = (params) => {
  return (
    <Box
      component={RouterLink}
      to={`${path.landOwnershipDetails}?${createSearchParams({
        id: params.id,
      })}`}
      sx={{ ...defaultStyles.renderButtonText }}
    >{`${params?.row?.id}`}</Box>
  );
};

export const RenderNewKml = (params) => {
  const status = params?.row?.newKmlStatus;

  // Admin-facing label + style for the new-KML review state
  const config: { label: string; bg: string; color: string } = !status
    ? { label: "Not Uploaded", bg: "#EEE", color: "#666" }
    : status === "PENDING_REVIEW"
    ? { label: "Uploaded", bg: "#1B7A6E", color: "#fff" }
    : status === "UNDER_QUERY"
    ? { label: "Under Query", bg: "#FBE9E7", color: "#C62828" }
    : { label: "Approved", bg: "#E8F5E9", color: "#2E7D32" };

  return (
    <Box
      component={RouterLink}
      to={`${path.landOwnershipDetails}?${createSearchParams({
        id: params.id,
      })}`}
      sx={{
        display: "inline-block",
        px: 1.2,
        py: 0.5,
        borderRadius: "14px",
        fontSize: "12px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        textDecoration: "none",
        backgroundColor: config.bg,
        color: config.color,
        cursor: status ? "pointer" : "default",
        pointerEvents: status ? "auto" : "none",
      }}
    >
      {config.label}
    </Box>
  );
};
